export type CollectionSourceId = 'fitbit' | 'ultrahuman' | 'healthkit';

// Off until set: a Fitbit on-request job must only be offered once the deployed
// worker understands that job kind. Turn it on after the worker release.
export const fitbitRecentCollectionEnabled = process.env.REACT_APP_FITBIT_RECENT_COLLECTION_ENABLED === 'true';

export const collectionSources = {
  fitbit: { id: 'fitbit', label: 'Fitbit', apiBase: '/api/fitbit-collection/researcher',
    exportRoot: 'fitbit-exports', supportsDaily: true, supportsRecentCollection: fitbitRecentCollectionEnabled },
  ultrahuman: { id: 'ultrahuman', label: 'Ultrahuman', apiBase: '/api/ultrahuman/researcher',
    exportRoot: 'ultrahuman-exports', supportsDaily: true, supportsRecentCollection: true },
  healthkit: { id: 'healthkit', label: 'HealthKit', apiBase: '', exportRoot: '', supportsDaily: false, supportsRecentCollection: false },
} as const;

export const ultrahumanEnabled = process.env.REACT_APP_ULTRAHUMAN_ENABLED !== 'false';
export const visibleCollectionSources: CollectionSourceId[] = ultrahumanEnabled
  ? ['fitbit', 'ultrahuman', 'healthkit'] : ['fitbit', 'healthkit'];
